/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const isClientPassword = /* GraphQL */ `
  query IsClientPassword($id: ID!, $clientPassword: String!) {
    isClientPassword(id: $id, clientPassword: $clientPassword) {
      id
      expiryDate
      clientPassword
      description
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        event {
          nextToken
        }
        eventLocationLookup {
          nextToken
        }
        updatedAt
        eventClientAccess {
          nextToken
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const getEventCompany = /* GraphQL */ `
  query GetEventCompany($id: ID!) {
    getEventCompany(id: $id) {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventCompanies = /* GraphQL */ `
  query ListEventCompanies(
    $filter: ModelEventCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        event {
          nextToken
        }
        eventLocationLookup {
          nextToken
        }
        updatedAt
        eventClientAccess {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      createdAt
      isDeleted
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        event {
          nextToken
        }
        eventLocationLookup {
          nextToken
        }
        updatedAt
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventLocation = /* GraphQL */ `
  query GetEventLocation($id: ID!) {
    getEventLocation(id: $id) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
        updatedAt
      }
      updatedAt
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventLocations = /* GraphQL */ `
  query ListEventLocations(
    $filter: ModelEventLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        updatedAt
        eventSlotGroup {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEventLocationLookup = /* GraphQL */ `
  query GetEventLocationLookup($id: ID!) {
    getEventLocationLookup(id: $id) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        event {
          nextToken
        }
        eventLocationLookup {
          nextToken
        }
        updatedAt
        eventClientAccess {
          nextToken
        }
      }
      updatedAt
    }
  }
`;
export const listEventLocationLookups = /* GraphQL */ `
  query ListEventLocationLookups(
    $filter: ModelEventLocationLookupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventLocationLookups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        isDeleted
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventCollectUserData = /* GraphQL */ `
  query GetEventCollectUserData($id: ID!) {
    getEventCollectUserData(id: $id) {
      id
      label
      questionType
      validation
      fieldType
      createdAt
      success
      error
      hint
      isDeleted
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
        updatedAt
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listEventCollectUserData = /* GraphQL */ `
  query ListEventCollectUserData(
    $filter: ModelEventCollectUserDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCollectUserData(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        questionType
        validation
        fieldType
        createdAt
        success
        error
        hint
        isDeleted
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventCollectUserDataOptions = /* GraphQL */ `
  query GetEventCollectUserDataOptions($id: ID!) {
    getEventCollectUserDataOptions(id: $id) {
      id
      options
      isDeleted
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        createdAt
        success
        error
        hint
        isDeleted
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventCollectUserDataOptions = /* GraphQL */ `
  query ListEventCollectUserDataOptions(
    $filter: ModelEventCollectUserDataOptionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCollectUserDataOptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        options
        isDeleted
        eventCollectUserData {
          id
          label
          questionType
          validation
          fieldType
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventBooking = /* GraphQL */ `
  query GetEventBooking($id: ID!) {
    getEventBooking(id: $id) {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        eventBooking {
          nextToken
        }
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
      }
    }
  }
`;
export const listEventBookings = /* GraphQL */ `
  query ListEventBookings(
    $filter: ModelEventBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventBookings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        startTime
        twentyFourHourReminder
        fortyEightHourReminder
        attendance
        searchField
        isDeleted
        updatedAt
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventCommsTemplate = /* GraphQL */ `
  query GetEventCommsTemplate($id: ID!) {
    getEventCommsTemplate(id: $id) {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      isDeleted
      createdAt
      updatedAt
    }
  }
`;
export const listEventCommsTemplates = /* GraphQL */ `
  query ListEventCommsTemplates(
    $filter: ModelEventCommsTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCommsTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        eventCommsTemplateAttachments {
          nextToken
        }
        isDeleted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventCommsTemplateAttachments = /* GraphQL */ `
  query GetEventCommsTemplateAttachments($id: ID!) {
    getEventCommsTemplateAttachments(id: $id) {
      id
      attachment
      key
      name
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        eventCommsTemplateAttachments {
          nextToken
        }
        isDeleted
        createdAt
        updatedAt
      }
      isDeleted
      createdAt
      updatedAt
    }
  }
`;
export const listEventCommsTemplateAttachments = /* GraphQL */ `
  query ListEventCommsTemplateAttachments(
    $filter: ModelEventCommsTemplateAttachmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCommsTemplateAttachments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        attachment
        key
        name
        EventCommsTemplate {
          id
          name
          emailSubject
          reminderEmailSubject
          emailTemplate
          reminderEmailTemplate
          smsReminderTemplate
          smsTemplate
          isDeleted
          createdAt
          updatedAt
        }
        isDeleted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const eventByCode = /* GraphQL */ `
  query EventByCode(
    $code: String
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const bookingBySearchField = /* GraphQL */ `
  query BookingBySearchField(
    $searchField: String
    $sortDirection: ModelSortDirection
    $filter: ModelEventBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingBySearchField(
      searchField: $searchField
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        startTime
        twentyFourHourReminder
        fortyEightHourReminder
        attendance
        searchField
        isDeleted
        updatedAt
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventSlotGroup = /* GraphQL */ `
  query GetEventSlotGroup($id: ID!) {
    getEventSlotGroup(id: $id) {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        updatedAt
        eventSlotGroup {
          nextToken
        }
      }
      updatedAt
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventSlotGroups = /* GraphQL */ `
  query ListEventSlotGroups(
    $filter: ModelEventSlotGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventSlotGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        updatedAt
        eventSlot {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEventSlot = /* GraphQL */ `
  query GetEventSlot($id: ID!) {
    getEventSlot(id: $id) {
      id
      time
      length
      type
      booked
      isDeleted
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        updatedAt
        eventSlot {
          nextToken
        }
      }
    }
  }
`;
export const listEventSlots = /* GraphQL */ `
  query ListEventSlots(
    $filter: ModelEventSlotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventSlots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        time
        length
        type
        booked
        isDeleted
        eventBooking {
          nextToken
        }
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventClientAccess = /* GraphQL */ `
  query GetEventClientAccess($id: ID!) {
    getEventClientAccess(id: $id) {
      id
      expiryDate
      clientPassword
      description
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        event {
          nextToken
        }
        eventLocationLookup {
          nextToken
        }
        updatedAt
        eventClientAccess {
          nextToken
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventClientAccesses = /* GraphQL */ `
  query ListEventClientAccesses(
    $filter: ModelEventClientAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventClientAccesses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        expiryDate
        clientPassword
        description
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
